// Newsletter images scroll animation
jQuery(function ($) {
  // Use a lower threshold on mobile/smaller viewports to handle cases where section is taller than viewport
  const isMobile = window.innerWidth < 768;
  const threshold = 0.3333;
  const rootMargin = isMobile ? '0px 0px 0px 0px' : '0px 0px -50px 0px';

  const observerOptions = {
    root: null,
    rootMargin: rootMargin,
    threshold: threshold
  };

  // const observer = new IntersectionObserver((entries) => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       // Add animated class with a slight delay when section comes into view
  //       setTimeout(() => {
  //         entry.target.classList.add('newsletter-animated');

  //         // Add hover-enabled class after animation completes (750ms delay + 700ms animation)
  //         setTimeout(() => {
  //           entry.target.classList.add('newsletter-hover-enabled');
  //         }, 1450);
  //       }, 50);
  //     } else {
  //       // Remove both classes when section goes out of view
  //       entry.target.classList.remove('newsletter-animated');
  //       entry.target.classList.remove('newsletter-hover-enabled');
  //     }
  //   });
  // }, observerOptions);

  // Observe the newsletter signup section
  const newsletterSection = document.querySelector('.newsletter-signup');
  if (newsletterSection) {
    //   observer.observe(newsletterSection);
    // Just show on load.
    newsletterSection.classList.add('newsletter-animated');
    // Add hover-enabled class after animation completes (750ms delay + 700ms animation)
    setTimeout(() => {
      newsletterSection.classList.add('newsletter-hover-enabled');
    }, 1450);
  }
  
});
